import IndiaCustomerMapSection from "../components/IndiaCustomerMapSection";

export default function IndiaCustomerMapPage() {
  return (
    <div className="india-map-page">
      <IndiaCustomerMapSection />
    </div>
  );
}
